export default __webpack_public_path__ + "static/media/regulatory--snow-chains--g2.84dc0228.png";